import { isIS24User } from './userUtils';

const IS24_LEGACY_GUEST_OWNER_HASHES = new Set<string>([
  '087d5d9e527ed2fdf54fb74969dc289723f2e5176e7d824fe9e32c75c4f556fa',
  '7ab4ac39208803932f8c99b330d7cd1418e394b0021402d30ec35fb78129af4b',

  'cb678ef215b44e2b05c9f38dea6855a3ec68599e46e8bd6b75e21fcf80ea9d37',
]);

const textEncoder = new TextEncoder();

async function sha256(value: string): Promise<string> {
  const digest = await globalThis.crypto.subtle.digest('SHA-256', textEncoder.encode(value));
  const bytes = new Uint8Array(digest);
  return Array.from(bytes)
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

export async function isIs24LegacyGuestWhitelisted(ownerId?: string): Promise<boolean> {
  if (!ownerId || !isIS24User() || !globalThis.crypto?.subtle) {
    return false;
  }

  const ownerHash = await sha256(ownerId.trim());
  return IS24_LEGACY_GUEST_OWNER_HASHES.has(ownerHash);
}
